import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@dru/ui';
import { BRAND } from '@dru/types';

/**
 * Where the old setup screens used to be.
 *
 * Setup guide, Company setup, Job roles and Medical configuration were the
 * customer's to complete; they are Dr Ultimate's now (docs/38) and left the
 * navigation. A bookmark or an old e-mail still points at them, so the address
 * answers with what happened and where to go, rather than a blank page or a
 * redirect that leaves the reader wondering where the screen went.
 */
const MOVED = {
  setup: {
    title: 'Company setup is done for you',
    hint: `${BRAND.name} support sets up your company, plants and medical package. There is nothing to complete here. To change your company details, contact ${BRAND.name} support.`,
    to: '/hr', label: 'Go to the dashboard',
  },
  'job-roles': {
    title: 'Job roles are not needed',
    hint: 'Medical cases no longer depend on job roles or hazards. Book appointments straight from an employee or from Appointments.',
    to: '/hr/employees', label: 'Go to employees',
  },
  'medical-config': {
    title: `Your medical package is set up by ${BRAND.name}`,
    hint: `You can see the package and the tests it includes under Settings. To change it, contact ${BRAND.name} support.`,
    to: '/hr/settings', label: 'See the medical package',
  },
} as const;

export function Moved({ what }: { what: keyof typeof MOVED }) {
  const m = MOVED[what];
  return (
    <div className="mx-auto max-w-xl py-8">
      <EmptyState
        title={m.title}
        hint={m.hint}
        action={<Link to={m.to}><Button>{m.label}</Button></Link>}
      />
    </div>
  );
}
